import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {PlatformSettings} from '../../../../models/platform-settings/platform-settings';
import {UserService} from '../../../services/user.service';
import {AbstractAchooComponent} from '../../abstract-achoo.component';
import {CampaignService} from '../../../services/campaign/campaign.service';
import {Location} from '@angular/common';
import {environment} from '../../../../environments/environment';
import {ObjectUtils} from '../../../utils/object.utils';
import {AchooPopupComponent} from '../../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../../services/modal/modal.service';
import {defaultPlatformSettings} from '../../../app.constants';

@Component({
  selector: 'platform-settings',
  templateUrl: './platform-settings.component.html',
  styleUrls: ['./platform-settings.component.scss']
})
export class PlatformSettingsComponent extends AbstractAchooComponent implements AfterViewInit, OnInit {

  @ViewChild('NotificationAfterSavingPlatformSettingSuccess')
  public notificationSaveSuccess: AchooPopupComponent;

  private env = environment;
  public currentSettings: PlatformSettings = new PlatformSettings();

  // TODO: change when sending domain can be customized
  public supportedDomains = [{id: 0, name: '@Influencerprogram.com'}];
  public uploadedLogoImage;
  constructor(protected userService: UserService,
              private location: Location,
              private campaignService: CampaignService,
              private modalService: ModalService) {
    super(userService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.userService.platformSettings.subscribe((setting) => {
      this.currentSettings = ObjectUtils.deepClone(setting);
      this.uploadedLogoImage = setting.logoContent;
    });
  }

  onLogoImageSelected(evt) {
    if (!evt || !evt.target || !evt.target.files) {
      return;
    }
    const selectedImageList = <FileList>((<any>evt.target).files);
    if (!selectedImageList.length) {
      return;
    }
    this.uploadPlatformLogo(selectedImageList[0]);
  }

  onUploadLogoSuccess(evt) {
    this.uploadPlatformLogo(evt[0]);
  }

  private uploadPlatformLogo(logo) {
    this.campaignService.validateMaterialUploadFile(logo);
    // Only upload one file on each select
    const formData = new FormData();
    formData.append('file', logo);

    this.campaignService.uploadFile(formData).subscribe(data => {
      if (data) {
        this.currentSettings.logo = data.id;
        this.uploadedLogoImage = data.diskFileName;
      }
    });
  }

  get firstHalfPriorityColors() {
    return this.currentSettings.chartColors.slice(0, 5);
  }

  get secondHalfPriorityColors() {
    return this.currentSettings.chartColors.slice(5, 10);
  }

  get firstHalfBottombarColors() {
    return this.currentSettings.bottombarButtonColors.slice(0, 2);
  }

  get secondHalfBottombarColors() {
    return this.currentSettings.bottombarButtonColors.slice(2, 4);
  }

  get firstHalfEmailButtonColors() {
    return this.currentSettings.emailButtonColors.slice(0, 1);
  }

  get secondHalfEmailButtonColors() {
    return this.currentSettings.emailButtonColors.slice(1, 2);
  }

  updatePlatformSettings() {
    return this.userService.savePlatformSettings(this.companyId, this.currentSettings).subscribe((res) => {
      this.userService.loadPlatformSettingByCampanyId(this.companyId);
      this.modalService.open(this.notificationSaveSuccess, undefined, true);
    });
  }

  resetAll() {
    this.currentSettings = ObjectUtils.deepClone(defaultPlatformSettings);
  }

  companyChangeCallback(companyId) {
    // callback when company change
  }

  get logoImage() {
    if (this.currentSettings.logo === 0 || this.currentSettings.logo == null) {
      return undefined;
    } else {
      return this.uploadedLogoImage;
    }
  }

  get defaultChartColors(): string[] {
    return defaultPlatformSettings.chartColors;
  }

  get defaultPlatformColor(): string {
    return defaultPlatformSettings.platformBgColor;
  }

  get defaultBottombarButtonColors(): string[] {
    return defaultPlatformSettings.bottombarButtonColors;
  }

  get defaultBottombarBgColor(): string {
    return defaultPlatformSettings.bottombarBgColor;
  }

  get defaultEmailButtonColors(): string[] {
    return defaultPlatformSettings.emailButtonColors;
  }

  get defaultEmailBgColor(): string {
    return defaultPlatformSettings.emailBgColor;
  }

  get isFreeUser() {
    return this.userService.isFreeUser();
  }

  trackColorChart(index, color) {
    return index;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/admin/platform-settings/platform-settings.component.ts